module.exports = __webpack_public_path__ + "img/measuring_meters_light.2ee78daf.svg";